/** @jsx jsx */
import { navigate } from 'gatsby'
import Link from '../components/Link'
//import 'typeface-roboto'
import { FaAlignJustify,FaMoon,FaSun } from 'react-icons/fa'

import {jsx,useColorMode,Box,Button} from 'theme-ui'

const Header = ({ siteTitle }) => {
  const [colorMode, setColorMode] = useColorMode()

   const isDark = colorMode === `dark`
  const toggleColorMode = (e) => {
    setColorMode(isDark ? `light` : `dark`)
  }

  return (
    
<div
     sx={{
     display:`flex`,
     mt:4,
     pb:0,

     position:`relative`,
     zIndex:1000,
    
      }}
    >
      <Box as="h1"  sx={{flexGrow:2}}>
      <Link
          to="/"
          sx={{
            color: `text`,   
            textDecoration: 'none',
            pl:1,m:0,
            pb:3,
            letterSpacing:[`-.2rem`,`-.4rem`],
          
            fontWeight: 800,
            fontSize: [`65px`,`140px`,`190px`]
          }}
        >
    
     
        K.O.M.
       
       
   
      
      {/* <span sx={{display:`ìnline-block`,
        textDecoration:`none`, 
        color:`text`,
        fontFamily:`serif`,
        position:`relative`,
        fontSize:[1,2,3],letterSpacing:`.3rem`,top:-30,lineHeight:1.2,fontWeight:100,fontStyle:`italic`}}> */}
          <p sx={{
            pl:2,
            pt:[3,3],
            mt:2,
            color:`text`,
        fontFamily:`serif`,
        position:`relative`,
        fontSize:[0,1],letterSpacing:[`.1rem`,`.2rem`,`.35rem`],top:-30,lineHeight:1.2,fontWeight:100,fontStyle:`italic`
            
            }}><span sx={{textDecoration:`underline`,color:`text`}}> Kulturnetz</span> Welterbe<br/> 
          <span sx={{display:`inline-block`,
          textDecoration:`none`,
          color:`text`
          }}>Oberes Mittelrheintal</span><br/><span>Gewinner des Welterbepreises </span><br/><span style={{fontWeight:700}}>Lore 2022</span></p>
     
     </Link>
      </Box>
      <Box sx={{justifyContent:`flex-end`,mt:[2,3]}}>
        <ul sx={{mt:2,pr:[0,2,2],listStyle:`none`}}>
          <li sx={{m:0,p:0}}>
          <Button aria-pressed="false"  name="toggleNightDay" sx={{
            color:`text`,
            outlineColor:`text`,
            background:`none`,
            border:0,cursor:`pointer`,
           
            height:38,
           
            }} aria-label="Toggle Color-Mode" onKeyDown={toggleColorMode} onClick={toggleColorMode}>
              {isDark?<span sx={{color:`text`,fontWeight:100,outline:`none`}}><FaSun fontSize="25" /></span>
              :
              <span sx={{color:`text`,fontWeight:100,border:`none`,outline:`none`}}><FaMoon fontSize="25" /></span>
              }
           </Button>
    
          </li>
          
       { typeof window !=="undefined" && window.location.pathname!=="/"?

         <li>
       
         <Button
         aria-label="open Menu close Menu"
          sx={{
            mt:0,
            pt:2,
           color:`text`,
           outlineColor:`text`,
           background:`none`,
           border:0,cursor:`pointer`,
           height:38,
          
           }}
         onClick={()=>navigate("/")}
         ><span sx={{color:`text`,fontWeight:100,outline:`none`}}><FaAlignJustify fontSize="25"/></span></Button>
     
         </li>
         
       :null
       }
         
          
        </ul>
      </Box>

      </div>
        
      

)}



export default Header
